var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-left"
  }, /*#__PURE__*/React.createElement("path", {
    id: "refresh",
    d: "M13.2339 4.7625C12.1464 3.675 10.6539 3 8.99641 3C5.68141 3 3.00391 5.685 3.00391 9C3.00391 12.315 5.68141 15 8.99641 15C11.7939 15 14.1264 13.0875 14.7939 10.5H13.2339C12.6189 12.2475 10.9539 13.5 8.99641 13.5C6.51391 13.5 4.49641 11.4825 4.49641 9C4.49641 6.5175 6.51391 4.5 8.99641 4.5C10.2414 4.5 11.3514 5.0175 12.1614 5.835L9.74641 8.25H14.9964V3L13.2339 4.7625Z",
    fill: "#DFE2E7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLeft);
export default __webpack_public_path__ + "static/media/icon-left.ad3cc7e54cf97f607635dc32d6517783.svg";
export { ForwardRef as ReactComponent };